import {ReadOnlyApiService} from "@/services/api/api.base.js";

export class FrServerApiService extends ReadOnlyApiService {
  constructor(resource, notifier, callback) {
    super(resource, notifier, callback);
  }

  async getReportsList() {
    const data = await super.get('reportslist', {});
    if (data == undefined || data.length == 0) {
      return {}
    }  
    return data  
  }

  async getAddress() {
    let res = '';
    const data = await super.get('address', {});
    if (data == undefined || data.length == 0) {
      return res
    }  
    if (data.fr_server) {
      res = data.fr_server
    }
    return res
    // return data.map((item) => this._parseDetail(DoughMap, item));
  }
}